(function () {
  if (window.__klHome) return;
  window.__klHome = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function start() {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (reduce || root.classList.contains('kla-still')) return;
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);
    root.classList.add('kl-home');

    /* Headings: words rise out of a mask */
    Array.prototype.forEach.call(d.querySelectorAll('.kl-h2'), function (h) {
      if (h.children.length) return;
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var o = d.createElement('span'); o.className = 'kl-hw';
        var s = d.createElement('span'); s.textContent = w;
        o.appendChild(s); h.appendChild(o);
        if (i < words.length - 1) h.appendChild(d.createTextNode(' '));
      });
      gsap.from(h.querySelectorAll('.kl-hw > span'), {
        yPercent: 115, duration: 1, stagger: 0.07, ease: 'power4.out',
        scrollTrigger: { trigger: h, start: 'top 90%', once: true }
      });
    });

    /* Buttons: gentle magnetic pull on desktop */
    if (fine) {
      Array.prototype.forEach.call(d.querySelectorAll('.kl-btn'), function (b) {
        b.style.transition = 'box-shadow .4s';
        var xTo = gsap.quickTo(b, 'x', { duration: 0.5, ease: 'power3' });
        var yTo = gsap.quickTo(b, 'y', { duration: 0.5, ease: 'power3' });
        b.addEventListener('mousemove', function (e) {
          var r = b.getBoundingClientRect();
          xTo((e.clientX - r.left - r.width / 2) * 0.25);
          yTo((e.clientY - r.top - r.height / 2) * 0.35);
        });
        b.addEventListener('mouseleave', function () { xTo(0); yTo(0); });
      });
    }

    /* Statement: words light up one by one as you scroll */
    var stmt = d.querySelector('.kl-stmt__text');
    if (stmt) {
      gsap.to(stmt.querySelectorAll('.kl-sw'), {
        opacity: 1, ease: 'none', stagger: 0.15,
        scrollTrigger: { trigger: stmt, start: 'top 85%', end: 'bottom 50%', scrub: true }
      });
    }

    /* Showcase: pinned horizontal scroll on desktop, swipe row elsewhere */
    var show = d.querySelector('[data-kl-show]');
    if (show) {
      var pin = show.querySelector('.kl-show__pin');
      var track = show.querySelector('.kl-show__track');
      var bar = show.querySelector('.kl-show__bar span');
      var mm = gsap.matchMedia();
      mm.add('(min-width: 1024px) and (hover: hover)', function () {
        var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth); };
        show.classList.add('kl-show--pinned');
        track.removeAttribute('tabindex');
        var tween = gsap.to(track, {
          x: function () { return -dist(); }, ease: 'none',
          scrollTrigger: {
            trigger: pin, start: 'top top', end: function () { return '+=' + dist(); },
            pin: true, scrub: 0.6, anticipatePin: 1, invalidateOnRefresh: true,
            onUpdate: function (self) { if (bar) bar.style.transform = 'scaleX(' + self.progress + ')'; }
          }
        });
        var onFocus = function (e) {
          var card = e.target.closest && e.target.closest('.kl-sc');
          var st = tween.scrollTrigger;
          if (!card || !st || !dist()) return;
          var ratio = Math.min(Math.max((card.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0)) / dist(), 0), 1);
          window.scrollTo(0, st.start + ratio * (st.end - st.start));
        };
        track.addEventListener('focusin', onFocus);
        return function () {
          show.classList.remove('kl-show--pinned');
          track.removeEventListener('focusin', onFocus);
          track.setAttribute('tabindex', '0');
        };
      });
    }

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  if (window.gsap && window.ScrollTrigger) start();
  else window.addEventListener('load', start);
})();
